var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal--cta",attrs:{"id":"modal-cancel-terms"}},[_c('h3',[_vm._v("\n        "+_vm._s(_vm.pageAttribute.get('cancel_terms_header', 'Terms of Cancellation'))+"\n    ")]),_vm._v(" "),_c('p',{staticClass:"modal--body",domProps:{"innerHTML":_vm._s(_vm.explainer)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }